import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorProtection = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      d="M12 11.65a.75.75 0 0 1 .75.75v5.958a3.5 3.5 0 1 1-7 0 .75.75 0 1 1 1.5 0 2 2 0 0 0 4 0V12.4a.75.75 0 0 1 .75-.75Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="M12.5 2.95a.75.75 0 0 0-1.5 0V4.2c-4.915.501-8.75 4.653-8.75 9.7 0 .03.002.059.005.087a.75.75 0 0 0 1.464.301c.276-.93 1.18-1.638 2.281-1.638 1.097 0 1.999.704 2.278 1.628a.75.75 0 0 0 1.444 0c.28-.924 1.18-1.628 2.278-1.628 1.097 0 1.999.704 2.278 1.628a.749.749 0 0 0 1.444 0c.28-.924 1.18-1.628 2.278-1.628 1.101 0 2.005.709 2.281 1.638a.75.75 0 0 0 1.464-.3.766.766 0 0 0 .005-.088c0-5.217-4.098-9.477-9.25-9.737V2.95Zm-.5 2.7a8.254 8.254 0 0 1 7.941 6.005A3.95 3.95 0 0 0 18 11.15a3.914 3.914 0 0 0-3 1.38 3.914 3.914 0 0 0-3-1.38 3.914 3.914 0 0 0-3 1.38 3.914 3.914 0 0 0-3-1.38c-.704 0-1.368.183-1.941.505A8.254 8.254 0 0 1 12 5.65Z"
    />
  </svg>
);
export default SvgTwoColorProtection;
